import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        error: false,
        loading: false,
        user: {
            id: 0,
            email: '',
            name: '',
            avatar: '',
            joinDate: 0,
            currentLesson: 0,
            level: 0,
            lessonReviewed: false,
            onboarding1: true,
            onboarding2: true,
            onboarding3: true
        },
        queue: [],
        practiceQueue: [],
        vocabulary: [],
        fmquestions: [],
        verbQuestions: [],
        verbQuestionTypes: [],
        paleoQuestions: [],
        primerData: [],
        lessons: [],
        images: [],
        paleoImage: "",
        paleoImages: [],
        primerImages: []
    },
    mutations,
    actions,
    getters,
    plugins: [createPersistedState({
        overwrite: true,
    })],
})